var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { App } from '@capacitor/app';
import { forgetMk } from '@popup/multichain/actions/mk.actions';
import { resetNav } from '@popup/multichain/actions/navigation.actions';
import { WitnessVotingSectionComponent } from '@popup/steem/pages/app-container/home/voting-section/witness-voting-section/witness-voting-section.component';
import { Theme, useThemeContext } from '@popup/theme.context';
import { Screen } from '@reference-data/screen.enum';
import React from 'react';
import { connect } from 'react-redux';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { MenuComponent } from 'src/common-ui/menu/menu.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import SettingsMenuItems from './settings-main-page-menu-items';
const SettingsMainPage = ({ forgetMk, resetNav }) => {
    const { toggleTheme, theme } = useThemeContext();
    const goToDiscord = () => {
        window.open('https://discord.gg/eFeUcBgkBg', '_blank');
    };
    const goToSteemPro = () => {
        window.open('https://www.steemit.com/@time.foundation', '_blank');
    };
    const goToTwitter = () => {
        window.open('https://twitter.com/ilnegro_max', '_blank');
    };
    //  const logout = () => {
    //    forgetMk();
    //	resetNav();
    //  };
    const logout = () => __awaiter(void 0, void 0, void 0, function* () {
        // // console.log('Logout chiamato');
        forgetMk();
        // // console.log('forgetMk eseguito');
        try {
            yield App.exitApp(); // Chiude l'app
            // // console.log('App chiusa');
        }
        catch (error) {
            console.error('Errore durante la chiusura dell\'app:', error);
        }
    });
    const getIcon = () => theme === Theme.DARK ? SVGIcons.MENU_THEME_LIGHT : SVGIcons.MENU_THEME_DARK;
    return (React.createElement("div", { className: "settings-main-page", "data-testid": `${Screen.SETTINGS_MAIN_PAGE}-page` },
        React.createElement(MenuComponent, { title: "popup_html_settings", isBackButtonEnable: true, rightAction: {
                icon: getIcon(),
                callback: toggleTheme,
                className: 'menu-toggle-theme',
            }, showDetachWindowOption: true, isCloseButtonDisabled: true, menuItems: SettingsMenuItems(logout) }),
        React.createElement(WitnessVotingSectionComponent, null),
        React.createElement("div", { className: "link-panel" },
            React.createElement(SVGIcon, { className: "network-icon", icon: SVGIcons.MENU_BOTTOM_BAR_DISCORD, onClick: goToDiscord, hoverable: true }),
            React.createElement(SVGIcon, { className: "network-icon", icon: SVGIcons.MENU_BOTTOM_BAR_STEEM, onClick: goToSteemPro, hoverable: true }),
            React.createElement(SVGIcon, { className: "network-icon", icon: SVGIcons.MENU_BOTTOM_BAR_TWITTER, onClick: goToTwitter, hoverable: true }))));
};
const mapStateToProps = (state) => {
    return {};
};
const connector = connect(mapStateToProps, {
    forgetMk,
    resetNav,
});
export const SettingsMainPageComponent = connector(SettingsMainPage);
